import { useInView } from "react-intersection-observer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { isThroughMainState } from "recoil/contentsAtom";
import { IPostContent, useInfiniteScrollQuery } from "api/postListApi";
import { useEffect } from "react";
import "./PostListContent.scoped.scss";
import ScrollLoading from "components/community/pageRight/PostContent/ScrollLoading";
import NotContent from "components/community/pageRight/PostContent/NotContent";
import PostListLoading from "components/common/loading/PostListLoading";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { deletetag } from "utils/DeleteTag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

function PostListContent() {
  const { t } = useTranslation();
  const setIsThroughMain = useSetRecoilState(isThroughMainState);
  const { service_code, title } = useParams();
  const navigate = useNavigate();
  const sectionTItle = title === undefined ? "all" : title;

  const { getBoard, getNextPage, getBoardIsSuccess, getNextPageIsPossible } =
    useInfiniteScrollQuery({ service_code, sectionTItle });

  const [ref, isView] = useInView();

  useEffect(() => {
    if (isView && getNextPageIsPossible) {
      getNextPage();
    }
  }, [isView, getBoard]);

  useEffect(() => {
    if (title === undefined) {
      return;
    } else {
      window.scrollTo(0, 0);
    }
  }, [title]);

  const dateCreated = (data: string) => {
    let created = new Date(data);
    let year = created.getFullYear();
    let month = String(created.getMonth() + 1).padStart(2, "0");
    let date = String(created.getDate()).padStart(2, "0");

    return `${year}-${month}-${date}`;
  };

  const checkPostState = (to: string) => {
    setIsThroughMain(true);
    navigate(to);
  };

  const width964 = useMediaQuery({
    query: "screen and (max-width: 964px)"
  });

  const compareDate = (date: string) => {
    const today = new Date();
    let createdDay = new Date(date);

    let differenceInValue = today.getTime() - createdDay.getTime();
    let shapeShiftTime = Math.abs(
      Math.ceil(differenceInValue / (1000 * 60 * 60 * 24))
    );

    if (shapeShiftTime <= 3) {
      return true;
    }
    return false;
  };

  return (
    <article className="wrap-article">
      <div className="article clearfix">
        <table className="tblListStyle">
          <colgroup>
            <col width={!width964 ? "84px" : "auto"} />
            <col />
            <col width={!width964 ? "166px" : "auto"} />
            <col width={!width964 ? "144px" : "auto"} />
            <col width={!width964 ? "106px" : "auto"} />
          </colgroup>
          <thead>
            <tr>
              <th className="thNo">No</th>
              <th>{t("Title")}</th>
              <th>{t("Writer")}</th>
              <th>{t("Date")}</th>
              <th className="thLike">{t("Like")}</th>
            </tr>
          </thead>

          <tbody>
            {getBoardIsSuccess ? (
              getBoard?.pages[0].result === 1 ? (
                getBoard.pages.map((pageData) =>
                  pageData.boardpage.map((i: IPostContent, idx: number) => (
                    <tr key={i.idx}>
                      <td className="tdNo">
                        {pageData.total - (pageData.currentpage - 1) * 10 - idx}
                      </td>
                      <td
                        className="txt-left"
                        onClick={() =>
                          checkPostState(`${sectionTItle}/${i.idx}`)
                        }
                      >
                        <Link to="#">
                          <span className="title">
                            {deletetag(i.title, [])}
                          </span>
                          {i.comment_count !== 0 ? (
                            <span className="comment-count">
                              [{i.comment_count}]
                            </span>
                          ) : null}
                          {compareDate(i.created_at) ? (
                            <span className="icon-new">N</span>
                          ) : null}
                        </Link>
                      </td>
                      <td className="userId">
                        {i.admin_flag === 1 ? (
                          <img
                            className="user-pic"
                            src={i.admin_icon}
                            alt="user-id"
                          />
                        ) : null}
                        <span>
                          {i.user_nickname === "" || i.user_nickname === null
                            ? i.user_id !== null && i.user_id.length > 10
                              ? `${i.user_id.slice(0, 10)}...`
                              : i.user_id
                            : i.user_nickname}
                        </span>
                      </td>
                      <td className="time">
                        {/*<span className="icon-clock" />*/}
                        {dateCreated(i.created_at)}
                      </td>
                      <td className="tdLike">
                        <FontAwesomeIcon icon={faHeart} />
                        {i.like_count}
                      </td>
                    </tr>
                  ))
                )
              ) : (
                <tr>
                  <td colSpan={5}>
                    <NotContent />
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td colSpan={5}>
                  <PostListLoading />
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <ScrollLoading
          loadingConditions={
            getNextPageIsPossible === true && getBoard?.pages[0].result === 1
          }
          viewRef={ref}
        />
      </div>
    </article>
  );
}

export default PostListContent;
